import { useEffect, useState } from "react";

import {
  emulatorAuthEnabled,
  getCurrentUser,
  linkGoogleAccount,
  observeAuth,
  signInAnonymousUser,
  signInGoogle,
  signInGoogleEmulator,
} from "../data/authRepository";

export function useAuth() {
  const [user, setUser] = useState(getCurrentUser);
  const [authReady, setAuthReady] = useState(false);
  const [authError, setAuthError] = useState<Error | null>(null);

  useEffect(
    () =>
      observeAuth(
        (u) => {
          setUser(u);
          setAuthReady(true);
        },
        (error) => {
          setAuthError(error);
          setAuthReady(true);
        },
      ),
    [],
  );

  return {
    user,
    authReady,
    authError,
    signInGoogle,
    signInGoogleEmu: emulatorAuthEnabled ? signInGoogleEmulator : undefined,
    signInAnonymous: signInAnonymousUser,
    linkGoogle: linkGoogleAccount,
  };
}
